import type { Notification } from "@/types/notification";
import { MasterNotificationCategoryEnum } from "@/__generated__/graphql";
import CoinSparkle from "@/assets/images/3d-icons/coin-sparkle.png";
import DiscountSparkle from "@/assets/images/3d-icons/discount-sparkle.png";
import Party from "@/assets/images/3d-icons/party.png";
import Employee from "@/assets/images/3d-icons/employee.png";
import InvoiceCard from "@/assets/images/3d-icons/invoice-card.png";
import CalendarCheckGreen from "@/assets/images/3d-icons/calendar-check-green.png";
import CalendarTime from "@/assets/images/3d-icons/calendar-time.png";
import ShieldSparkle from "@/assets/images/3d-icons/shield-sparkle.png";
import Bell from "@/assets/images/3d-icons/bell.png";

function hasKeyword(text: string, keywords: string[]): boolean {
  const lower = text.toLowerCase();
  return keywords.some((k) => lower.includes(k));
}
const SHORT_BODY_ICON_RULES: [string[], string][] = [
  [["how was your visit", "your visit report"], Bell],
  [["welcome to luce"], Party],
];

export function getNotificationIcon(notification: Notification): string {
  const category = notification.category;
  const shortBody =
    [notification.subject, notification.shortBody]
      .filter(Boolean)
      .join(" ")
      .toLowerCase() || "";
  const fromShortBody = SHORT_BODY_ICON_RULES.find(([keywords]) =>
    hasKeyword(shortBody, keywords),
  );
  if (fromShortBody) return fromShortBody[1];
  switch (category) {
    case MasterNotificationCategoryEnum.PromoAndDiscount:
      return hasKeyword(shortBody, ["referral", "refer", "invite"])
        ? CoinSparkle
        : DiscountSparkle;
    case MasterNotificationCategoryEnum.Authentication:
      return ShieldSparkle;
    case MasterNotificationCategoryEnum.Jobs:
      return Employee;
    case MasterNotificationCategoryEnum.Billing:
      return InvoiceCard;
    case MasterNotificationCategoryEnum.VisitReminder:
      return hasKeyword(shortBody, ["confirmed"])
        ? CalendarCheckGreen
        : CalendarTime;
    default:
      if (hasKeyword(shortBody, ["welcome to luce", "welcome"])) return Party;
      if (hasKeyword(shortBody, ["report", "issue", "complaint"]))
        return ShieldSparkle;
      return Bell;
  }
}
